/* eslint-disable */

import 'es6-promise/auto'
import '@babel/polyfill'
import '@helper/sentry'

import Vue from 'vue'
import './setup'
import i18n from './i18n'
import apolloProvider from '@lib/apollo-provider'
import { apply as applyPolyfills } from '@polyfills'
import routing from '@mixins/routing'


applyPolyfills()

import VueHead from 'vue-head'

Vue.use(VueHead)
Vue.mixin(routing)

import { sync } from 'vuex-router-sync'
import router from './router'
import store from './store'
import App from '@vuecmp/App'

sync(store, router)

async function createApp(pathName){
  if(document.querySelector('#mfv-insurance-request')) {
    new Vue({
      el: '#mfv-insurance-request',
      store,
      components: {
        App,
      },
      template: '<app></app>',
      apolloProvider,
      router,
      i18n
    })
  }
  // Reset router to target location if necessary
  if (pathName && router.currentRoute.path != pathName) {
    router.push({path: pathName})
  }
}

function vehicleType() {
  const { vehicleRegistrationType } = store.state.newContract.insurance
  switch (vehicleRegistrationType) {
    case '03':
      return 'motorcycle'
    case '02':
      return 'van'
    case '01':
    default:
      return 'car'
  }
}

window.dextraMfv = { createApp, routerEvents: router.events, vehicleType, isAgent: () => store.state.agent.isAgent }

export default createApp()
